export default __webpack_public_path__ + "static/media/TRURO_2020_COVER.7cad592d.jpg";